const blogPreviewData = {
  config: {
    diseno: 3,
    color: '#1ab394',
    tipoLetra: 2,
  },
  articulos: [
    {
      _id: 'art-1',
      titulo: 'Cómo organizar tu semana para comer sano sin sacrificar el sabor',
      descripcion: 'Planifica con inteligencia tus comidas para evitar tentaciones y mantener energía durante toda la semana.',
      imagenUrl: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=900&q=80',
      likes: Array.from({ length: 28 }),
      comentarios: Array.from({ length: 11 }),
      esCompartido: false,
    },
    {
      _id: 'art-2',
      titulo: 'Desayunos rápidos y nutritivos para comenzar el día con fuerza',
      descripcion: 'Ideas fáciles que combinan proteínas, fibra y grasas buenas para cargar pilas desde temprano.',
      imagenUrl: 'https://images.unsplash.com/photo-1505253216366-88c5c95c50e5?auto=format&fit=crop&w=900&q=80',
      likes: Array.from({ length: 18 }),
      comentarios: Array.from({ length: 6 }),
      esCompartido: true,
    },
    {
      _id: 'art-3',
      titulo: 'Mitos y realidades sobre las dietas cetogénicas',
      descripcion: 'Un vistazo equilibrado a los riesgos y beneficios, para que tomes una decisión informada.',
      imagenUrl: 'https://images.unsplash.com/photo-1514996937319-344454492b37?auto=format&fit=crop&w=900&q=80',
      likes: Array.from({ length: 32 }),
      comentarios: Array.from({ length: 9 }),
      esCompartido: false,
    },
    {
      _id: 'art-4',
      titulo: 'Snacks saludables que puedes preparar en menos de 10 minutos',
      descripcion: 'Recetas para saciar antojos sin caer en ultraprocesados llenos de azúcares añadidos.',
      imagenUrl: 'https://images.unsplash.com/photo-1478144592103-25e218a04891?auto=format&fit=crop&w=900&q=80',
      likes: Array.from({ length: 14 }),
      comentarios: Array.from({ length: 4 }),
      esCompartido: true,
    },
    {
      _id: 'art-5',
      titulo: 'Cómo leer etiquetas de alimentos sin volverte loco',
      descripcion: 'Aprende a identificar ingredientes claves y comparar opciones para escoger lo mejor.',
      imagenUrl: 'https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?auto=format&fit=crop&w=900&q=80',
      likes: Array.from({ length: 21 }),
      comentarios: Array.from({ length: 7 }),
      esCompartido: false,
    },
  ],
};

const fontOptions = [
  { id: 1, name: 'Poppins', family: '"Poppins", "Inter", sans-serif' },
  { id: 2, name: 'Inter', family: '"Inter", "Poppins", sans-serif' },
  { id: 3, name: 'Quicksand', family: '"Quicksand", "Poppins", sans-serif' },
  { id: 4, name: 'Montserrat', family: '"Montserrat", "Poppins", sans-serif' },
  { id: 5, name: 'Open Sans', family: '"Open Sans", "Poppins", sans-serif' },
];

const designOptions = [
  { id: 1, label: 'Clásico' },
  { id: 2, label: 'Minimal' },
  { id: 3, label: 'Moderno' },
];

export { fontOptions, designOptions };

export default blogPreviewData;
